module.exports = __webpack_public_path__ + "media/images/logos/windeurope-eolis2023-6322b587313fa019959e101d540f8cfd.svg";